import { SchedulerTypes } from "devextreme-react/cjs/scheduler";
import { IconButtonDelete, Row } from "../../../core/components";

interface ChecklistSchduleTooltipProps {
    appointmentData: SchedulerTypes.Appointment & {
        id: number,
        idChecklist: number
    };
    handleDelete: (appointmentId: number) => void;
    onAppointmentClick?: (e: { appointmentData: any }) => void;
}

export default function ChcklistScheduleTooltip(props: ChecklistSchduleTooltipProps) {
    return (
        <div
            onClick={e => {
                e.stopPropagation();
                props.onAppointmentClick?.({ appointmentData: props.appointmentData });
            }}
            onDoubleClick={e => e.stopPropagation()}>
            <Row alignItems="center">
                {props.appointmentData.text}
                <Row.End>
                    <IconButtonDelete size='small' onClick={() => {
                        props.handleDelete(props.appointmentData.id)
                    }} />
                </Row.End>
            </Row>
        </div>
    )
}
